import type { PopDisplays_ChannelFrame } from 'c-sdk/Types';
import type { BaseEntity } from '../../BaseEntity';
import type { Displays_FrameType } from './Displays_FrameType';
import type { Displays_Partner } from './Displays_Partner';
import type { Displays_Market } from './Displays_Market';
import type { Displays_Owner } from './Displays_Owner';
import type { Displays_Pack } from './Displays_Pack';
import type { Displays_Resolution } from './Displays_Resolution';
import type { Displays_FileType } from './Displays_FileType';
import type { Displays_LineItem } from './Displays_LineItem';
import type { Displays_Tag } from './Displays_Tag';
import type { Displays_OperationalTime } from './Displays_OperationalTime';
import type { Displays_Vendor } from './Displays_Vendor';
import type { Displays_AudienceVersion } from './Displays_AudienceVersion';

export enum Displays_ScreenType {
    Display = 'Display',
    Logo = 'Logo',
    Classic = 'Classic',
}

export enum Displays_ScreenAnimationType {
    Static = 'Static',
    Motion = 'Motion',
    Subtle = 'Subtle',
    RotatingScrolling = 'Rotating-Scrolling',
}

export type Displays_Screen = BaseEntity & {
    ext_id?: string;

    type: Displays_ScreenType;
    description?: string;
    brochurelink?: string;
    env?: string;

    // strintiger
    slots?: string;
    // strinteger
    sov?: string;
    // strinteger
    slot_length?: string;
    animation?: Displays_ScreenAnimationType;
    size?: string;
    sales_code?: string;
    // strinteger
    surface_area?: string;
    // strinteger
    height?: string;
    // strinteger
    width?: string;
    brochure?: string;
    brochure_file?: File;
    location?: string;
    address?: string;
    postcode?: string;
    lat?: string;
    long?: string;
    town?: string;
    tv_region?: string;
    conurbation?: string;
    channel?: string;
    frame?: string;

    frame_id?: string;
    previous_frame_id?: string;

    unilive_id?: number;

    partner_id?: number;
    market_id?: number;
    frame_type_id?: number;

    partner?: Displays_Partner;
    market?: Displays_Market;
    frameType?: Displays_FrameType;

    mediaOwners?: Displays_Owner[];
    owner?: Displays_Owner;

    packs?: Displays_Pack[];

    // include
    resolutions?: Displays_Resolution[];

    // include
    fileTypes?: Displays_FileType[];

    // include
    lineItem?: Displays_LineItem;
    // include
    tags?: Displays_Tag[];

    operationalTimes?: Displays_OperationalTime[];
    // include
    displaysVendorIds?: Displays_Vendor[];

    // include
    audienceVersion: Displays_AudienceVersion[];

    // include
    channelFrame?: PopDisplays_ChannelFrame[];
    channelFrameSummary?: {
        first_seen: string;
        last_seen: string;
    };
};
type FrameSearchScreen = Displays_Screen & {
    line_item_name: string;
    status: number;
};
type Conflict = {
    vendor_id: string;
    options: FrameSearchScreen[];
};

export type FrameSearchScreens = {
    screens: FrameSearchScreen[];
    missing: string[];
    conflicts: Conflict[];
};
